import { Nøkkeltall } from "./nokkeltall";
import { NøkkeltallListe } from "./nokkeltallListe";
import { NøkkeltallTekst } from "./nokkeltallTekst";

export const nøkkeltall = [Nøkkeltall, NøkkeltallListe, NøkkeltallTekst];
